export default function SubjectContent({ children }) {
  return (
    <div className="sm:rounded p-2 sm:p-5 border border-brd-primary mt-[10px] relative bg-secondary-background rounded flex items-center ">
      {children}
    </div>
  )
}
